import { __ } from '@wordpress/i18n';
import { Spinner } from '@wordpress/components';

const Loading = ({ text = __('Yükleniyor...', 'kanews') }) => {
    return (
        <div className="kanews-loading">
            <Spinner />
            <p>{text}</p>
        </div>
    );
};

export default Loading; 